import { takeLatest, call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import I18n from 'i18n'
import editExternalCourse from 'api/administration/externalCourses/Edit'
import { ExternalCourseModel } from 'models/externalCourse.model'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/externalCourses.action'

async function handleEditExternalCourse(
  externalCourse: ExternalCourseModel,
  externalCourseId: string
) {
  return await editExternalCourse(externalCourse, externalCourseId)
}

function* editExternalCourseEffectSaga(action: any) {
  try {
    yield call(
      handleEditExternalCourse,
      action.payload.externalCourse,
      action.payload.externalCourseId
    )
    if (action.payload.onlySave) {
      yield put(push('/administration/external_courses/'))
    } else {
      yield put(
        fromActions.Actions.getExternalCourse(action.payload.externalCourseId)
      )
      yield put(
        push(
          `/administration/external_courses/${action.payload.externalCourseId}/lessons/`
        )
      )
    }
    SuccessToast(I18n.t('administration.toastMessages.published'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.publishError'))
    console.log('error: ', error)
  }
}

export function* publishExternalCourseWatcherSaga() {
  yield takeLatest(
    fromActions.PUBLISH_EXTERNAL_COURSE,
    editExternalCourseEffectSaga
  )
}
